<script setup lang="ts">
import { MessageCircle } from 'lucide-vue-next'
import { openSupport } from '@/composables/useSupport'

/**
 * This was a `mailto:` link. On a phone, or in any browser with no mail client
 * registered, it did nothing — leaving somebody stuck at a payment page
 * believing there was no way to ask for help. It opens the support form now,
 * which posts somewhere the team can actually read and answer it.
 */
</script>

<template>
  <section class="surface-card p-6">
    <h4 class="mb-4 font-semibold text-ink">Need help?</h4>
    <button
      type="button"
      class="flex w-full items-center justify-center gap-2 rounded-xl bg-surface-2 py-3 text-sm font-medium text-ink transition-colors hover:bg-brand-soft hover:text-brand-soft-text"
      @click="openSupport()"
    >
      <MessageCircle class="size-4" />
      Message the Bindle team
    </button>
    <p class="mt-3 text-xs text-muted">We reply the same working day.</p>
  </section>
</template>
